import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import ReactPiwik from 'react-piwik'
import PropTypes from 'prop-types'

class Matomo extends Component
{
    static propTypes = {
        history: PropTypes.object.isRequired,
        configuration: PropTypes.object,
        isEnabled: PropTypes.bool.isRequired,
    }

    constructor(props)
    {
        super(props)
        this.trackPageView = this.trackPageView.bind(this)
    }

    componentDidMount()
    {
        const { history, configuration, isEnabled } = this.props

        if(isEnabled === false)
        {
            return
        }

        new ReactPiwik({
            url: configuration.url,
            siteId: configuration.id,
        })

        this.trackPageView(history.location)

        history.listen((location, action) => {
            if(action === 'PUSH')
            {
                this.trackPageView(location)
            }
        })
    }

    trackPageView(location)
    {
        ReactPiwik.push(['setCustomUrl', location.pathname + location.search]);
        ReactPiwik.push(['disableCookies']);
        ReactPiwik.push(['trackPageView']);
    }

    render()
    {
        return this.props.children
    }
}

export default withRouter(Matomo)
